import { render, staticRenderFns } from "./ReferalPage.vue?vue&type=template&id=b509409c"
var script = {}
import style0 from "./ReferalPage.vue?vue&type=style&index=0&id=b509409c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports